/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductionSitesForSupplierQueryResponse,
  FindProductionSitesForSupplierQueryParams,
} from "../types/FindProductionSitesForSupplier.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductionSitesForSupplierQueryKey = (
  params: FindProductionSitesForSupplierQueryParams
) =>
  [
    { url: "/v1/production-site/find-production-sites-for-supplier" },
    ...(params ? [params] : []),
  ] as const

export type FindProductionSitesForSupplierQueryKey = ReturnType<
  typeof findProductionSitesForSupplierQueryKey
>

/**
 * @summary Find production sites for a supplier
 * {@link /v1/production-site/find-production-sites-for-supplier}
 */
export async function findProductionSitesForSupplier(
  params: FindProductionSitesForSupplierQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductionSitesForSupplierQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site/find-production-sites-for-supplier`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductionSitesForSupplierQueryOptions(
  params: FindProductionSitesForSupplierQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductionSitesForSupplierQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductionSitesForSupplierQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductionSitesForSupplierQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductionSitesForSupplier(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find production sites for a supplier
 * {@link /v1/production-site/find-production-sites-for-supplier}
 */
export function useFindProductionSitesForSupplier<
  TData = ResponseConfig<FindProductionSitesForSupplierQueryResponse>,
  TQueryData = ResponseConfig<FindProductionSitesForSupplierQueryResponse>,
  TQueryKey extends QueryKey = FindProductionSitesForSupplierQueryKey,
>(
  params: FindProductionSitesForSupplierQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductionSitesForSupplierQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductionSitesForSupplierQueryKey(params)

  const query = useQuery(
    {
      ...findProductionSitesForSupplierQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
